module.exports = __webpack_public_path__ + "media/images/our_apps/apple_decoration_md-e056c263cc1d9fc5c8b443eda20f0b2b.png";